export const normalizeCategoryValue = (value) =>
  String(value ?? "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

export const getPartnerIdentifier = (partner) => {
  if (!partner || typeof partner !== "object") return "";
  return (
    partner.userId ||
    partner.id ||
    partner._id ||
    partner.partnerId ||
    partner.email ||
    partner.phone ||
    partner.mobile ||
    partner.name ||
    ""
  );
};

export const buildCityCategoryCoverage = (partners, categories) => {
  const safePartners = Array.isArray(partners) ? partners : [];
  const safeCategories = Array.isArray(categories) ? categories : [];

  const categoryDetails = safeCategories.map((cat) => {
    const uniquePartnerIds = new Set();

    safePartners.forEach((partner) => {
      const partnerKey = getPartnerIdentifier(partner);
      const services = Array.isArray(partner?.services) ? partner.services : [];
      const hasMatchingService = services.some((service) => {
        const serviceCategoryId = service?.categoryId;
        const serviceCategoryName = service?.categoryName;
        const categoryIdMatch =
          serviceCategoryId != null && String(serviceCategoryId).trim() === String(cat?.categoryId ?? "").trim();
        const categoryNameMatch =
          normalizeCategoryValue(serviceCategoryName) === normalizeCategoryValue(cat?.name);

        return categoryIdMatch || categoryNameMatch;
      });

      if (!hasMatchingService) return;

      if (partnerKey) {
        uniquePartnerIds.add(partnerKey);
      } else {
        uniquePartnerIds.add(`${partner?.name || "unknown"}-${partner?.phone || "unknown"}-${Math.random()}`);
      }
    });

    const partnerCount = uniquePartnerIds.size;

    return {
      categoryId: cat?.categoryId,
      categoryName: cat?.name,
      partnerCount,
      meetsThreshold: partnerCount >= 25,
    };
  });

  const coveredCategories = categoryDetails.filter((cat) => cat.meetsThreshold).length;
  const totalCategories = safeCategories.length;
  const coveragePercent = totalCategories > 0 ? Math.round((coveredCategories / totalCategories) * 100) : 0;

  return {
    categoryDetails,
    coveredCategories,
    coveragePercent,
  };
};
